import { Checkbox } from '@/components/ui/checkbox'
import { useTranslation } from 'react-i18next'

interface LegendItemProps {
    bgClass: string
    borderClass: string
    label: string
}

function LegendItem({ bgClass, borderClass, label }: LegendItemProps) {
    return (
        <div className="flex items-center gap-1.5">
            <span
                className={`inline-block w-4 h-4 rounded ${bgClass} border ${borderClass}`}
            />
            <span className="text-slate-700">{label}</span>
        </div>
    )
}

interface OverviewTableLegendProps {
    mergeAllocated: boolean
    onMergeChange: (value: boolean) => void
}

/** Color legend + merge-allocated checkbox */
export function OverviewTableLegend({
    mergeAllocated,
    onMergeChange,
}: OverviewTableLegendProps) {
    const { t } = useTranslation('report')

    return (
        <div className="flex flex-wrap items-center justify-between gap-4 text-xs">
            <div className="flex flex-wrap items-center gap-4">
                <span className="text-slate-600 font-medium">
                    {t('overview.legend')}:
                </span>
                {!mergeAllocated && (
                    <>
                        <LegendItem
                            bgClass="bg-purple-100"
                            borderClass="border-purple-300"
                            label={t('overview.pb_previous_year')}
                        />
                        <LegendItem
                            bgClass="bg-blue-100"
                            borderClass="border-blue-300"
                            label={t('overview.pb_current_year')}
                        />
                    </>
                )}
                {mergeAllocated && (
                    <LegendItem
                        bgClass="bg-blue-100"
                        borderClass="border-blue-300"
                        label={t('overview.pb_merged')}
                    />
                )}
                <LegendItem
                    bgClass="bg-orange-100"
                    borderClass="border-orange-300"
                    label={`KPB: ${t('overview.kpb_full')}`}
                />
                <LegendItem
                    bgClass="bg-green-100"
                    borderClass="border-green-300"
                    label={t('overview.allocated_by_type')}
                />
                <LegendItem
                    bgClass="bg-amber-100"
                    borderClass="border-amber-300"
                    label={t('overview.unallocated_by_type')}
                />
                <LegendItem
                    bgClass="bg-indigo-100"
                    borderClass="border-indigo-300"
                    label={t('overview.total_by_type')}
                />
                <LegendItem
                    bgClass="bg-emerald-100"
                    borderClass="border-emerald-300"
                    label={t('overview.total_summary')}
                />
            </div>
            <label className="flex items-center gap-2 cursor-pointer">
                <Checkbox
                    checked={mergeAllocated}
                    onCheckedChange={(checked) => onMergeChange(!!checked)}
                />
                <span className="text-slate-600">
                    {t('overview.merge_allocated')}
                </span>
            </label>
        </div>
    )
}
